import { createSlice } from '@reduxjs/toolkit'
import { fetchTransactions, filterTransactions } from './transactionActions'

const initialState = {
  value: 0,
  loading: false,
  transactions: []
}

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
  },
  extraReducers:{
       // fetch transactions  -------------------- ---------------------------------------------------------------
       [fetchTransactions.pending]: (state) => {
        state.loading = true
      },
      [fetchTransactions.fulfilled]: (state, { payload }) => {
        state.loading = false
        state.transactions = payload.message
      },
      [fetchTransactions.rejected]: (state, { payload }) => {
        state.loading = false
      },
        // filter transactions  -------------------- ---------------------------------------------------------------
        [filterTransactions.pending]: (state) => {
          state.loading = true
        },
        [filterTransactions.fulfilled]: (state, { payload }) => {
          state.loading = false
          state.transactions = payload.message
        },
        [filterTransactions.rejected]: (state, { payload }) => {
          state.loading = false
        },
  }
})

// Action creators are generated for each case reducer function
export const { increment, decrement, } = transactionSlice.actions

export default transactionSlice.reducer